module.exports = __webpack_public_path__ + "amcharts/images/xIconH.gif";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=amcharts/images/[name].[ext]!./~/amstock3/amcharts/images/xIconH.gif
// module id = 285
// module chunks = 0